import React, { Component } from "react";
import { Card, CardBody } from "reactstrap";
import Axios from "axios";
import { configuration } from "../../appConfig";
import ReportHeader from "./ReportHeader";
import ReportFooter from "./ReportFooter";
import ReportFooter_Swiss from "./ReportFooter_Swiss";
import ReportHeader_Swiss from "./ReportHeader_Swiss";
import Spinner from "../../spinner/index";

export class ReportDamageImages extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isScanListRecord: "",
      Hood: [],
      Roof: [],
      RightRoofFrame: [],
      LeftRoofFrame: [],
      TrunkCover: [],
      Trunk: [],
      TrunkAllImage: [],
      right: [],
      Left: [],
      damageImageLoader: false,
      imageAvailability: {},
    };
  }
  async componentDidMount() {
    this.vinFolderList();
    setTimeout(() => {
     this.getScanImages();
    }, 2000);
    this.checkAllImagesExist();
  }
  vinFolderList = async () => {
    const partnerId = localStorage.getItem("partnerId");
    const selectedFile = localStorage.getItem("selectedFile");
    if (partnerId) {
      const response = await Axios.get(
        configuration.resultTxt +
        "?vin=" +
        selectedFile +
        "&partnerId=" +
        partnerId
      );
      if (response.data[0]) {
        this.setState({
          isScanListRecord: response.data[0].isScanListRecord,
        });
      }
    } else {
      this.props.history.push("/login");
    }
  };

  getTotalDents = (part) => {
    let dents = 0;
    this.props.jsonData && this.props.jsonData.length > 0 && this.props.jsonData.forEach((row) => {
      if (row.Part === part) {
        dents = row.TotalDents
      }
    })
    return dents;
  }

  getScanImages = async () => {
    const partnerId = localStorage.getItem("partnerId");
    const selectedFile = localStorage.getItem("selectedFile");
    this.setState({
      damageImageLoader: true,
    });

    try {
      const response = await Axios.get(configuration.getScanImages, {
        params: {
          partnerId: partnerId,
          vin: selectedFile,
        },
      });

      if (response && response.data) {
        const { data } = response;

        const filterImages = (images, keyword) => {
          const filtered = images
            ? images.filter((image) => image.includes(keyword))
            : [];
          return filtered.length > 0 ? filtered[0] : "";
        };

        const getImages = (images, ...keywords) => {
          return keywords.map((keyword) => filterImages(images, keyword));
        };

        const getFilteredImage = (images, keyword) => {
          const filtered = images
            ? images.filter(
              (image) => image.includes(keyword) && image.includes("_1")
            )
            : [];
          return filtered.length > 0 ? filtered[0] : [""];
        };
        const getTrunkOtherImage = (images, keyword) => {
          const filtered =
            images != ""
              ? images.filter(
                (image) =>
                  image.includes(keyword) &&
                  (image.includes("_2") || image.includes("_3"))
              )
              : [];
          return filtered.length > 0 ? filtered : [];
        };

        const getSuffixImages = (images, keyword) => {
          const filteredNumber = 2
      
            const result = images && images.filter((image, index) => {
              // if (image === "") {
              //   return true; 
              // }
              
              return index >= 0 && index <= filteredNumber;
            });
      
        return result;
          };

        const Left = [
          ...getImages(
            data.LeftFrontFender_damage || data.Left_damage,
            "LeftFrontFender"
          ),
          ...getImages(
            data.LeftFrontDoor_damage || data.Left_damage,
            "LeftFrontDoor"
          ),
          ...getImages(
            data.LeftBackDoor_damage || data.Left_damage,
            "LeftBackDoor"
          ),
          ...getImages(
            data.LeftBackFender_damage || data.Left_damage,
            "LeftBackFender"
          ),
        ].slice(0, 4);

        const right = [
          ...getImages(
            data.RightFrontFender_damage || data.right_damage,
            "RightFrontFender"
          ),
          ...getImages(
            data.RightFrontDoor_damage || data.right_damage,
            "RightFrontDoor"
          ),
          ...getImages(
            data.RightBackDoor_damage || data.right_damage,
            "RightBackDoor"
          ),
          ...getImages(
            data.RightBackFender_damage || data.right_damage,
            "RightBackFender"
          ),
        ].slice(0, 4);

        this.setState({
          Hood: getSuffixImages(data.Hood_damage, "Hood"),
          Roof: getSuffixImages(data.Roof_damage, "Roof"),
          RightRoofFrame: getSuffixImages(data.RightRoofFrame_damage, "RightRoofFrame"),
          LeftRoofFrame: getSuffixImages(data.LeftRoofFrame_damage, "LeftRoofFrame"),
          TrunkCover: [getFilteredImage(data.TrunkCover_damage, "TrunkCover")],
          Trunk: [getFilteredImage(data.Trunk_damage, "Trunk")],
          TrunkAllImage: getTrunkOtherImage(data.Trunk_damage, "Trunk"),
          right: right,
          Left: Left,
          damageImageLoader: false,
        });
      }
    } catch (error) {
      console.error("Error fetching scan images:", error);
      this.setState({
        damageImageLoader: false,
      });
    }
  };

  lang = (word) => {
    const { lang, words } = this.props;
    return words[word] ? words[word][lang] : word;
  };

  checkAllImagesExist = () => {
    const partnerId = localStorage.getItem("partnerId");
    const selectedFile = localStorage.getItem("selectedFile");
    
    const imagePaths = {
      underbody: `${configuration.imagePath}/scanImages/${partnerId}/${selectedFile}/damages/Report_Underbody_1.jpg`,
      LeftFrontTyre: `${configuration.imagePath}/scanImages/${partnerId}/${selectedFile}/damages/Report_LeftFrontTyre_1.jpg`,
      LeftBackTyre: `${configuration.imagePath}/scanImages/${partnerId}/${selectedFile}/damages/Report_LeftBackTyre_1.jpg`,
      RightFrontTyre: `${configuration.imagePath}/scanImages/${partnerId}/${selectedFile}/damages/Report_RightFrontTyre_1.jpg`,
      RightBackTyre: `${configuration.imagePath}/scanImages/${partnerId}/${selectedFile}/damages/Report_RightBackTyre_1.jpg`,
    };
  
    const checkImage = (url) => {
      return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => resolve(true);
        img.onerror = () => resolve(false);
        img.src = url;
      });
    };
  
    const checkAllImages = async () => {
      const results = {};
      
      for (const [key, url] of Object.entries(imagePaths)) {
        const isAvailable = await checkImage(url);
        results[key] = isAvailable;
      }
  
      this.setState({ imageAvailability: results });
    };
  
    checkAllImages();
  };
  

  render() {
    const client = localStorage.getItem("client");
    const partnerId = localStorage.getItem("partnerId");
    const selectedFile = localStorage.getItem("selectedFile");
    const { jsonData, isDentShowingReport } = this.props;
    const { imageAvailability } = this.state;
    const trunkImages_2 = this.state.TrunkAllImage.filter((r) => (r.includes("Trunk_2") || r.includes("TrunkCover_2")));
    const trunkImages_3 = this.state.TrunkAllImage.filter((r) => (r.includes("Trunk_3") || r.includes("TrunkCover_3")));
    return (
      <>
        {this.state.damageImageLoader === true ? (
          <Spinner />
        ) : (
          <>
            {this.state.isScanListRecord === "0" && (
              <>
                {/* Hood-partsimages */}
                <div
                  className="row row-zero page-break-row report-full-wrapper"
                  data-content-name={this.lang("Page")}
                >
                  <div className="col-sm-12 full-height-col col-zero">
                    <Card>
                      <CardBody className="col-zero">
                        <div className="newFormatReport_wrapper">
                          <ReportHeader_Swiss />
                          <div className="container">
                            <div className="row title-row-main">
                              <div className="col-sm-12 col-zero">
                                <h3 className="report-title">
                                  {this.lang("Hood report")}
                                </h3>
                              </div>
                            </div>
                            <div className="all_hood_images">
                              {this.state.Hood &&
                                this.state.Hood.length > 0 &&
                                this.state.Hood.map((r, i) => {
                                  return (
                                    isDentShowingReport == 1 && r != '' && (
                                      <div key={`dent-${i}`} className="dent_report_position">
                                        <div className="row left-side-row">
                                          <div className="col text-center">
                                            <div className="col-bg">
                                              <p>{this.lang("Dents")}<span>: {this.getTotalDents('Hood')}</span></p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    )
                                  );
                                })}
                              {this.state.Hood &&
                                this.state.Hood.length > 0 &&
                                this.state.Hood.map((r, i) => {
                                  return (
                                    <div className="row left-side-row">
                                      <div className="col-sm-12 col-zero all-images-wrapper">
                                        {r == "" ? (
                                          <img
                                            alt=""
                                            className="default-image-wrapper"
                                            src={require("../../assets/img/brand/default-image.png")}
                                            zoom="20"
                                          />
                                        ) : (
                                          <img alt="" src={`${r}?t=${new Date().getTime()}`} zoom="20" />
                                        )}
                                      </div>
                                    </div>
                                  );
                                })}
                            </div>
                          </div>
                        </div>
                      </CardBody>
                      <ReportFooter_Swiss reportType="newReportFull" />
                    </Card>
                  </div>
                </div>

                {/* Roof-partsimages */}
                <div
                  className="row row-zero page-break-row report-full-wrapper"
                  data-content-name={this.lang("Page")}
                >
                  <div className="col-sm-12 full-height-col col-zero">
                    <Card>
                      <CardBody className="col-zero">
                        <div className="newFormatReport_wrapper">
                          <ReportHeader_Swiss />
                          <div className="container">
                            <div className="row title-row-main">
                              <div className="col-sm-12 col-zero">
                                <h3 className="report-title">
                                  {this.lang("Roof report")}
                                </h3>
                              </div>
                            </div>
                            <div className="all_roof_images">
                              <div className="row left-side-row">
                                <div className="col-3 col-zero">
                                  <div className="row all-images-wrapper row-zero">
                                    <div className="col-sm-12 col-zero">
                                      {this.state.LeftRoofFrame && this.state.LeftRoofFrame.length > 0 && this.state.LeftRoofFrame.map((r, i) => {
                                        return (
                                          isDentShowingReport == 1 && r != '' && (
                                            <div key={`dent-${i}`} className="dent_report_position">
                                              <div className="row left-side-row">
                                                <div className="col text-center">
                                                  <div className="col-bg">
                                                    <p>{this.lang("Dents")}<span>: {this.getTotalDents('LeftRoofFrame')}</span></p>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          )
                                        );
                                      })}
                                      {this.state.LeftRoofFrame &&
                                        this.state.LeftRoofFrame.length > 0 &&
                                        this.state.LeftRoofFrame.map((r, i) => {
                                          return r == "" ? (
                                            <img
                                              alt=""
                                              className="default-image-wrapper"
                                              src={require("../../assets/img/brand/default-image.png")}
                                              zoom="20"
                                            />
                                          ) : (
                                            <img alt="" src={`${r}?t=${new Date().getTime()}`} zoom="20" />
                                          );
                                        })}
                                    </div>
                                  </div>
                                </div>
                                <div className="col-6 col-zero">
                                  <div className="row all-images-wrapper row-zero">
                                    <div className="col-sm-12 col-zero">
                                      {this.state.Roof && this.state.Roof.length > 0 && this.state.Roof.map((r, i) => {
                                        return (
                                          isDentShowingReport == 1 && r != '' && (
                                            <div key={`dent-${i}`} className="dent_report_position">
                                              <div className="row left-side-row">
                                                <div className="col text-center">
                                                  <div className="col-bg">
                                                    <p>{this.lang("Dents")}<span>: {this.getTotalDents('Roof')}</span></p>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          )
                                        );
                                      })}
                                      {this.state.Roof &&
                                        this.state.Roof.length > 0 &&
                                        this.state.Roof.map((r, i) => {
                                          return r == "" ? (
                                            <img
                                              alt=""
                                              className="default-image-wrapper"
                                              src={require("../../assets/img/brand/default-image.png")}
                                              zoom="20"
                                            />
                                          ) : (
                                            <img alt="" src={`${r}?t=${new Date().getTime()}`} zoom="20" />
                                          );
                                        })}
                                    </div>
                                  </div>
                                </div>
                                <div className="col-3 col-zero">
                                  <div className="row all-images-wrapper row-zero">
                                    <div className="col-sm-12 col-zero">
                                      {this.state.RightRoofFrame && this.state.RightRoofFrame.length > 0 && this.state.RightRoofFrame.map((r, i) => {
                                        return (
                                          isDentShowingReport == 1 && r != '' && (
                                            <div key={`dent-${i}`} className="dent_report_position">
                                              <div className="row left-side-row">
                                                <div className="col text-center">
                                                  <div className="col-bg">
                                                    <p>{this.lang("Dents")}<span>: {this.getTotalDents('RightRoofFrame')}</span></p>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          )
                                        );
                                      })}
                                      {this.state.RightRoofFrame &&
                                        this.state.RightRoofFrame.length > 0 &&
                                        this.state.RightRoofFrame.map(
                                          (r, i) => {
                                            return r == "" ? (
                                              <img
                                                alt=""
                                                className="default-image-wrapper"
                                                src={require("../../assets/img/brand/default-image.png")}
                                                zoom="20"
                                              />
                                            ) : (
                                              <img alt="" src={`${r}?t=${new Date().getTime()}`} zoom="20" />
                                            );
                                          }
                                        )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </CardBody>
                      <ReportFooter_Swiss reportType="newReportFull" />
                    </Card>
                  </div>
                </div>

                {/* LFF-LFD-LBD-LBF-RFF-RFD-RBD-RBF-partsimages */}

                <div
                  className="row row-zero page-break-row report-full-wrapper"
                  data-content-name={this.lang("Page")}
                >
                  <div className="col-sm-12 full-height-col col-zero">
                    <Card>
                      <CardBody className="col-zero">
                        <div className="newFormatReport_wrapper">
                          <ReportHeader_Swiss />
                          <div className="container">
                            <div className="row left-side-row">
                              <div className="col-lg-6 col-md-6 left-row-img-wrapper rotate-90-deg">
                                <div className="row title-row-main">
                                  <div className="col-12">
                                    <h3 className="report-title">
                                      {this.lang("Left")}
                                    </h3>
                                  </div>
                                </div>
                                <div>
                                  {this.state.Left &&
                                    this.state.Left.length > 0 &&
                                    this.state.Left.map((r, i) => {
                                      const partName = r.split("/")[r.split("/").length - 1].split(".")[0].split("_")[1]
                                      return (
                                        <div className="row left-side-row">
                                          {
                                            isDentShowingReport == 1 && r != '' &&
                                            <div className="dent_report_position">
                                              <div className="row left-side-row">
                                                <div className="col text-center">
                                                  <div className="col-bg">
                                                    <p>{this.lang("Dents")}<span>: {this.getTotalDents(partName)}</span></p>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          }
                                          <div className="col-sm-12 rotate-col">
                                            {r == "" ? (
                                              <img
                                                alt=""
                                                className="default-image-wrapper"
                                                src={require("../../assets/img/brand/default-image.png")}
                                                zoom="20"
                                              />
                                            ) : (
                                              <img
                                                alt=""
                                                className=""
                                                src={`${r}?t=${new Date().getTime()}`}
                                                zoom="20"
                                              />
                                            )}
                                          </div>
                                        </div>
                                      );
                                    })}
                                </div>
                              </div>
                              <div className="col-lg-6 col-md-6 left-row-img-wrapper rotate-270-deg">
                                <div className="row title-row-main">
                                  <div className="col-12">
                                    <h3 className="report-title">
                                      {this.lang("Right")}
                                    </h3>
                                  </div>
                                </div>
                                <div>
                                  {this.state.right &&
                                    this.state.right.length > 0 &&
                                    this.state.right.map((r, i) => {
                                      const partName = r.split("/")[r.split("/").length - 1].split(".")[0].split("_")[1]
                                      return (
                                        <div className="row left-side-row">
                                          {isDentShowingReport == 1 && r != '' &&
                                            <div className="dent_report_position">
                                              <div className="row left-side-row">
                                                <div className="col text-center">
                                                  <div className="col-bg">
                                                    <p>{this.lang("Dents")}<span>: {this.getTotalDents(partName)}</span></p>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          }
                                          <div className="col-sm-12 rotate-col">
                                            {r == "" ? (
                                              <img
                                                alt=""
                                                className="default-image-wrapper"
                                                src={require("../../assets/img/brand/default-image.png")}
                                                zoom="20"
                                              />
                                            ) : (
                                              <img
                                                alt=" "
                                                className=""
                                                src={`${r}?t=${new Date().getTime()}`}
                                                zoom="20"
                                              />
                                            )}
                                          </div>
                                        </div>
                                      );
                                    })}
                                </div>
                              </div>
                              <div className="center-dotted-image-left-right"></div>
                            </div>
                          </div>
                        </div>
                      </CardBody>
                      <ReportFooter_Swiss reportType="newReportFull" />
                    </Card>
                  </div>
                </div>

                {/* Trunk & TrunkCover - partsimages */}

                <div
                  className="row row-zero page-break-row report-full-wrapper"
                  data-content-name={this.lang("Page")}
                >
                  <div className="col-sm-12 full-height-col col-zero">
                    <Card>
                      <CardBody className="p-0">
                        <div className="newFormatReport_wrapper">
                          <ReportHeader_Swiss />
                          <div className="container trunk_images_wrapper">
                            <div className="row left-side-row">
                              <div className="col-sm-12 col-zero">
                                <h3 className="report-title">
                                  {this.lang("Trunk report")}
                                </h3>
                              </div>
                            </div>
                            {this.state.TrunkCover &&
                              this.state.TrunkCover.length > 0 &&
                              this.state.TrunkCover.map((r, i) => {
                                return (
                                  <div className="row trunk_row_wrapper row-zero">
                                    <div className="col-lg-7 col-md-7 col-sm-12">
                                      {isDentShowingReport == 1 && r != '' &&
                                        <div className="dent_report_position">
                                          <div className="row left-side-row">
                                            <div className="col text-center">
                                              <div className="col-bg">
                                                <p>{this.lang("Dents")}<span>: {this.getTotalDents('TrunkCover')}</span></p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      }
                                      <div className="row trunk-bottom-row">
                                        <div className="col-12 trunk-img-col">
                                          {r == "" ? (
                                            <img
                                              alt=""
                                              className="default-image-wrapper"
                                              src={require("../../assets/img/brand/default-image.png")}
                                              zoom="20"
                                            />
                                          ) : (
                                            <img alt="" src={`${r}?t=${new Date().getTime()}`} zoom="20" />
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            {this.state.Trunk &&
                              this.state.Trunk.length > 0 &&
                              this.state.Trunk.map((r, i) => {
                                return (
                                  <div className="row trunk_row_wrapper row-zero">
                                    <div className="col-lg-7 col-md-7 col-sm-12">
                                      {isDentShowingReport == 1 && r != '' &&
                                        <div className="dent_report_position">
                                          <div className="row left-side-row">
                                            <div className="col text-center">
                                              <div className="col-bg">
                                                <p>{this.lang("Dents")}<span>: {this.getTotalDents('Trunk')}</span></p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      }
                                      <div className="row trunk-bottom-row">
                                        <div className="col-12 trunk-img-col">
                                          {r == "" ? (
                                            <img
                                              alt=""
                                              className="default-image-wrapper"
                                              src={require("../../assets/img/brand/default-image.png")}
                                              zoom="20"
                                            />
                                          ) : (
                                            <img
                                              alt=""
                                              className=""
                                              src={`${r}?t=${new Date().getTime()}`}
                                              zoom="20"
                                            />
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                          </div>
                        </div>
                      </CardBody>
                      <ReportFooter_Swiss reportType="newReportFull" />
                    </Card>
                  </div>
                </div>

                {/* trunk report_2 & report_3 image */}

                {this.state.TrunkAllImage.length > 0 && (
                  <div
                    className="row row-zero page-break-row report-full-wrapper"
                    data-content-name={this.lang("Page")}
                  >
                    <div className="col-sm-12 full-height-col col-zero">
                      <Card>
                        <CardBody className="p-0">
                          <div className="newFormatReport_wrapper">
                            <ReportHeader_Swiss />
                            <div className="container trunk_images_wrapper">
                              <div className="row left-side-row">
                                <div className="col-sm-12 col-zero">
                                  <h3 className="report-title">
                                    {this.lang("Trunk report")}
                                  </h3>
                                </div>
                              </div>
                                <>
                                  {trunkImages_2.length > 0 ? (
                                    trunkImages_2.map((r, i) => {
                                      return (
                                        <div key={`report2-${i}`} className="row trunk_row_wrapper row-zero">
                                        <div className="col-lg-7 col-md-7 col-sm-12">
                                          {isDentShowingReport == 1 && r !== '' && (
                                            <div className="dent_report_position">
                                              <div className="row left-side-row">
                                                <div className="col text-center">
                                                  <div className="col-bg">
                                                    <p>
                                                      {this.lang("Dents")}
                                                      <span>: {this.getTotalDents('Trunk')}</span>
                                                    </p>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          )}
                                          <div className="row trunk-bottom-row">
                                            <div className="col-12 trunk-img-col">
                                              <img alt="" src={`${r}?t=${new Date().getTime()}`} zoom="20" />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      )
                                    })
                                  ) : (
                                    <div className="row trunk_row_wrapper row-zero">
                                      <div className="col-lg-7 col-md-7 col-sm-12">
                                        <div className="row trunk-bottom-row">
                                          <div className="col-12 trunk-img-col">
                                            <img
                                              alt=""
                                              className="default-image-wrapper"
                                              src={require("../../assets/img/brand/default-image.png")}
                                              zoom="20"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}

                                  {/* Display _3 images or default image */}
                                  {trunkImages_3.length > 0 ? (
                                    trunkImages_3.map((r, i) => (
                                      <div key={`report3-${i}`} className="row trunk_row_wrapper row-zero">
                                        <div className="col-lg-7 col-md-7 col-sm-12">
                                          {isDentShowingReport == 1 && r !== '' && (
                                            <div className="dent_report_position">
                                              <div className="row left-side-row">
                                                <div className="col text-center">
                                                  <div className="col-bg">
                                                    <p>
                                                      {this.lang("Dents")}
                                                      <span>: {this.getTotalDents('Trunk')}</span>
                                                    </p>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          )}
                                          <div className="row trunk-bottom-row">
                                            <div className="col-12 trunk-img-col">
                                              <img alt="" src={`${r}?t=${new Date().getTime()}`} zoom="20" />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    ))
                                  ) : (
                                    <div className="row trunk_row_wrapper row-zero">
                                      <div className="col-lg-7 col-md-7 col-sm-12">
                                        <div className="row trunk-bottom-row">
                                          <div className="col-12 trunk-img-col">
                                            <img
                                              alt=""
                                              className="default-image-wrapper"
                                              src={require("../../assets/img/brand/default-image.png")}
                                              zoom="20"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </>
                            </div>
                          </div>
                        </CardBody>
                        <ReportFooter_Swiss reportType="newReportFull" />
                      </Card>
                    </div>
                  </div>
                )}

                {/* {partnerId == "501-240515" && ( */}
                {imageAvailability.underbody &&
                  <>
                  <div
                    className="row row-zero page-break-row report-full-wrapper"
                    data-content-name={this.lang("Page")}
                  >
                    <div className="col-sm-12 full-height-col col-zero">
                      <Card>
                        <CardBody className="col-zero">
                          <div className="newFormatReport_wrapper">
                            <ReportHeader_Swiss />
                            <div className="container">
                              <div className="row title-row-main">
                                <div className="col-sm-12 col-zero">
                                  <h3 className="report-title">
                                    {this.lang("Underbody")}
                                  </h3>
                                </div>
                              </div>
                              <div className="">
                                <div className="row left-side-row justify-content-center">
                                  <div className="col-lg-6 col-md-6 col-sm-6 underbody_image">
                                    {isDentShowingReport == 1 &&
                                      <div className="dent_report_position">
                                        <div className="row left-side-row">
                                          <div className="col text-center">
                                            <div className="col-bg">
                                              <p>{this.lang("Dents")}<span>: {this.getTotalDents('Underbody')}</span></p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    }
                                    <div className="underbody-image-row-wrapper">
                                      <img
                                        alt=""
                                        className="partImage w-100"
                                        src={`${configuration.imagePath
                                          }/scanImages/${partnerId}/${selectedFile}/Report_${"Underbody"}_1.jpg`}
                                        zoom="20"
                                        onError={(img_comp) =>
                                          (img_comp.target.src = require("../../assets/img/brand/default-image.png"))
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </CardBody>
                        <ReportFooter_Swiss reportType="newReportFull" />
                      </Card>
                    </div>
                  </div>
                  </>
                }
               
                {/* )} */}
                {/* Tyres Side Images - 1*/}

                {/* {partnerId == "501-240515" && ( */}
                <>
                  <div className="row row-zero page-break-row report-full-wrapper"
                    data-content-name={this.lang("Page")}>
                    <div className="col-sm-12 full-height-col p-0">
                      <Card>
                        <div id="main_footer">
                          <ReportHeader_Swiss />
                        </div>
                        <CardBody className="col-zero">
                          <div className="general_damage_report_wrapper">
                            <div className="container main_container">
                              <div className="row main_row">
                                <div className="col-sm-12">
                                  <h3 className="general-report-title">
                                    {this.lang("Tyres")}
                                  </h3>
                                </div>
                              </div>
                              <div className="row main_row">
                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                  <div className="general-damage-image-row tyre-four-image">
                                    {isDentShowingReport == 1 && imageAvailability.LeftFrontTyre &&
                                      <div className="dent_report_position">
                                        <div className="row left-side-row">
                                          <div className="col text-center">
                                            <div className="col-bg">
                                              <p>{this.lang("Dents")}<span>: {this.getTotalDents('LeftFrontTyre')}</span></p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    }
                                    {/* <img src="https://drivenscan.com/scanImages/002-sa/2024031300004/Report_LeftFrontTyre_1.jpg" alt="Part Image Name" /> */}{" "}
                                    <img
                                      alt=""
                                      className="partImage"
                                      src={`${configuration.imagePath}/scanImages/${partnerId}/${selectedFile}/damages/Report_LeftFrontTyre_1.jpg`}
                                      zoom="20"
                                      onError={(img_comp) =>
                                        (img_comp.target.src = require("../../assets/img/brand/default-image.png"))
                                      }
                                    />
                                  </div>
                                  <div className="general-damage-data-row tyre-table-wrapper">
                                    <div className="damag-table-wrapper">
                                      <div className="table-responsive">
                                        <table className="table table-bordered">
                                          <thead>
                                            <tr>
                                              <th colspan={1}>
                                                {this.lang("Part")}
                                              </th>
                                              <th colspan={3}>
                                                {this.lang("LeftFrontTyre")}
                                              </th>
                                            </tr>
                                            <tr>
                                              <th>{this.lang("Make")}</th>
                                              <th>{this.lang("Type")}</th>
                                              <th>Dimension</th>
                                              <th>DotCode</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <tr>
                                              <td>
                                                {Array.isArray(jsonData) &&
                                                  jsonData.map((item) => {
                                                    if (
                                                      item.Part ===
                                                      "LeftFrontTyre"
                                                    ) {
                                                      return item.Make
                                                        ? item.Make
                                                        : <p></p>;
                                                    }
                                                  })}
                                              </td>
                                              <td>
                                                {Array.isArray(jsonData) &&
                                                  jsonData.map((item) => {
                                                    if (
                                                      item.Part ===
                                                      "LeftFrontTyre"
                                                    ) {
                                                      return item.TyreType
                                                        ? item.TyreType
                                                        : <p></p>;
                                                    }
                                                  })}
                                              </td>
                                              <td>
                                                {Array.isArray(jsonData) &&
                                                  jsonData.map((item) => {
                                                    if (
                                                      item.Part ===
                                                      "LeftFrontTyre"
                                                    ) {
                                                      return item.TyreDimension
                                                        ? item.TyreDimension
                                                        : <p></p>;
                                                    }
                                                  })}
                                              </td>
                                              <td>
                                                {Array.isArray(jsonData) &&
                                                  jsonData.map((item) => {
                                                    if (
                                                      item.Part ===
                                                      "LeftFrontTyre"
                                                    ) {
                                                      return item.DotCode
                                                        ? item.DotCode
                                                        : <p></p>;
                                                    }
                                                  })}
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                  <div className="general-damage-image-row tyre-four-image">
                                    {isDentShowingReport == 1 && imageAvailability.LeftBackTyre &&
                                      <div className="dent_report_position">
                                        <div className="row left-side-row">
                                          <div className="col text-center">
                                            <div className="col-bg">
                                              <p>{this.lang("Dents")}<span>: {this.getTotalDents('LeftBackTyre')}</span></p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    }
                                    {/* <img src="https://drivenscan.com/scanImages/002-sa/2024031300004/Report_LeftBackTyre_1.jpg" alt="Part Image Name" /> */}{" "}
                                    <img
                                      alt=""
                                      className="partImage"
                                      src={`${configuration.imagePath}/scanImages/${partnerId}/${selectedFile}/damages/Report_LeftBackTyre_1.jpg`}
                                      zoom="20"
                                      onError={(img_comp) =>
                                        (img_comp.target.src = require("../../assets/img/brand/default-image.png"))
                                      }
                                    />
                                  </div>
                                  <div className="general-damage-data-row tyre-table-wrapper">
                                    <div className="damag-table-wrapper">
                                      <div className="table-responsive">
                                        <table className="table table-bordered">
                                          <thead>
                                            <tr>
                                              <th colspan={1}>
                                                {this.lang("Part")}
                                              </th>
                                              <th colspan={3}>
                                                {this.lang("LeftBackTyre")}
                                              </th>
                                            </tr>
                                            <tr>
                                              <th>{this.lang("Make")}</th>
                                              <th>{this.lang("Type")}</th>
                                              <th>{this.lang("Dimension")}</th>
                                              <th>{this.lang("DotCode")}</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <tr>
                                              <td>
                                                {Array.isArray(jsonData) &&
                                                  jsonData.map((item) => {
                                                    if (
                                                      item.Part ===
                                                      "LeftBackTyre"
                                                    ) {
                                                      return item.Make
                                                        ? item.Make
                                                        : <p></p>;
                                                    }
                                                  })}
                                              </td>
                                              <td>
                                                {Array.isArray(jsonData) &&
                                                  jsonData.map((item) => {
                                                    if (
                                                      item.Part ===
                                                      "LeftBackTyre"
                                                    ) {
                                                      return item.TyreType
                                                        ? item.TyreType
                                                        : <p></p>;
                                                    }
                                                  })}
                                              </td>
                                              <td>
                                                {Array.isArray(jsonData) &&
                                                  jsonData.map((item) => {
                                                    if (
                                                      item.Part ===
                                                      "LeftBackTyre"
                                                    ) {
                                                      return item.TyreDimension
                                                        ? item.TyreDimension
                                                        : <p></p>;
                                                    }
                                                  })}
                                              </td>
                                              <td>
                                                {Array.isArray(jsonData) &&
                                                  jsonData.map((item) => {
                                                    if (
                                                      item.Part ===
                                                      "LeftBackTyre"
                                                    ) {
                                                      return item.DotCode
                                                        ? item.DotCode
                                                        : <p></p>;
                                                    }
                                                  })}
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                  <div className="general-damage-image-row tyre-four-image">
                                    {isDentShowingReport == 1 && imageAvailability.RightFrontTyre &&
                                      <div className="dent_report_position">
                                        <div className="row left-side-row">
                                          <div className="col text-center">
                                            <div className="col-bg">
                                              <p>{this.lang("Dents")}<span>: {this.getTotalDents('RightFrontTyre')}</span></p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    }
                                    {/* <img src="https://drivenscan.com/scanImages/002-sa/2024031300004/Report_RightFrontTyre_1.jpg" alt="Part Image Name" /> */}{" "}
                                    <img
                                      alt=""
                                      className="partImage"
                                      src={`${configuration.imagePath}/scanImages/${partnerId}/${selectedFile}/damages/Report_RightFrontTyre_1.jpg`}
                                      zoom="20"
                                      onError={(img_comp) =>
                                        (img_comp.target.src = require("../../assets/img/brand/default-image.png"))
                                      }
                                    />
                                  </div>
                                  <div className="general-damage-data-row tyre-table-wrapper">
                                    <div className="damag-table-wrapper">
                                      <div className="table-responsive">
                                        <table className="table table-bordered">
                                          <thead>
                                            <tr>
                                              <th colspan={1}>
                                                {this.lang("Part")}
                                              </th>
                                              <th colspan={3}>
                                                {this.lang("RightFrontTyre")}
                                              </th>
                                            </tr>
                                            <tr>
                                              <th>{this.lang("Make")}</th>
                                              <th>{this.lang("Type")}</th>
                                              <th>Dimension</th>
                                              <th>DotCode</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <tr>
                                              <td>
                                                {Array.isArray(jsonData) &&
                                                  jsonData.map((item) => {
                                                    if (
                                                      item.Part ===
                                                      "RightFrontTyre"
                                                    ) {
                                                      return item.Make
                                                        ? item.Make
                                                        : <p></p>;
                                                    }
                                                  })}
                                              </td>
                                              <td>
                                                {Array.isArray(jsonData) &&
                                                  jsonData.map((item) => {
                                                    if (
                                                      item.Part ===
                                                      "RightFrontTyre"
                                                    ) {
                                                      return item.TyreType
                                                        ? item.TyreType
                                                        : <p></p>;
                                                    }
                                                  })}
                                              </td>
                                              <td>
                                                {Array.isArray(jsonData) &&
                                                  jsonData.map((item) => {
                                                    if (
                                                      item.Part ===
                                                      "RightFrontTyre"
                                                    ) {
                                                      return item.TyreDimension
                                                        ? item.TyreDimension
                                                        : <p></p>;
                                                    }
                                                  })}
                                              </td>
                                              <td>
                                                {Array.isArray(jsonData) &&
                                                  jsonData.map((item) => {
                                                    if (
                                                      item.Part ===
                                                      "RightFrontTyre"
                                                    ) {
                                                      return item.DotCode
                                                        ? item.DotCode
                                                        : <p></p>;
                                                    }
                                                  })}
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                  <div className="general-damage-image-row tyre-four-image">
                                    {isDentShowingReport == 1 && imageAvailability.RightBackTyre &&
                                      <div className="dent_report_position">
                                        <div className="row left-side-row">
                                          <div className="col text-center">
                                            <div className="col-bg">
                                              <p>{this.lang("Dents")}<span>: {this.getTotalDents('RightBackTyre')}</span></p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    }
                                    {/* <img src="https://drivenscan.com/scanImages/002-sa/2024031300004/Report_RightFrontTyre_1.jpg" alt="Part Image Name" /> */}{" "}
                                    <img
                                      alt=""
                                      className="partImage"
                                      src={`${configuration.imagePath}/scanImages/${partnerId}/${selectedFile}/damages/Report_RightBackTyre_1.jpg`}
                                      zoom="20"
                                      onError={(img_comp) =>
                                        (img_comp.target.src = require("../../assets/img/brand/default-image.png"))
                                      }
                                    />
                                  </div>
                                  <div className="general-damage-data-row tyre-table-wrapper">
                                    <div className="damag-table-wrapper">
                                      <div className="table-responsive">
                                        <table className="table table-bordered">
                                          <thead>
                                            <tr>
                                              <th colspan={1}>
                                                {this.lang("Part")}
                                              </th>
                                              <th colspan={3}>
                                                {this.lang("RightBackTyre")}
                                              </th>
                                            </tr>
                                            <tr>
                                              <th>{this.lang("Make")}</th>
                                              <th>{this.lang("Type")}</th>
                                              <th>Dimension</th>
                                              <th>DotCode</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <tr>
                                              <td>
                                                {Array.isArray(jsonData) &&
                                                  jsonData.map((item) => {
                                                    if (
                                                      item.Part ===
                                                      "RightBackTyre"
                                                    ) {
                                                      return item.Make
                                                        ? item.Make
                                                        : <p></p>;
                                                    }
                                                  })}
                                              </td>
                                              <td>
                                                {Array.isArray(jsonData) &&
                                                  jsonData.map((item) => {
                                                    if (
                                                      item.Part ===
                                                      "RightBackTyre"
                                                    ) {
                                                      return item.TyreType
                                                        ? item.TyreType
                                                        : <p></p>;
                                                    }
                                                  })}
                                              </td>
                                              <td>
                                                {Array.isArray(jsonData) &&
                                                  jsonData.map((item) => {
                                                    if (
                                                      item.Part ===
                                                      "RightBackTyre"
                                                    ) {
                                                      return item.TyreDimension
                                                        ? item.TyreDimension
                                                        : <p></p>;
                                                    }
                                                  })}
                                              </td>
                                              <td>
                                                {Array.isArray(jsonData) &&
                                                  jsonData.map((item) => {
                                                    if (
                                                      item.Part ===
                                                      "RightBackTyre"
                                                    ) {
                                                      return item.DotCode
                                                        ? item.DotCode
                                                        : <p></p>;
                                                    }
                                                  })}
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </CardBody>
                        <ReportFooter_Swiss reportType="newReportFull" />
                      </Card>
                    </div>
                  </div>
                </>
                {/* )} */}
              </>
            )}
          </>
        )}
      </>
    );
  }
}

export default ReportDamageImages;
